import React from "react";
import CardsLink from "./CardsLink";
import DeclinationContainerNew from "Containers/DeclinationContainerNew";

const CardsLinkStreet = (props) => {
	let { data, defaultItems } = props;

	return (
		<DeclinationContainerNew>
			<CardsLink data={data} place={"улицы"} defaultItems={defaultItems} />
		</DeclinationContainerNew>
	);
};

export default CardsLinkStreet;
